const env: Record<string, string> = {
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN ?? "",
  MIXPANEL_API_HOST: process.env.REACT_APP_MIXPANEL_API_HOST ?? "",
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL ?? "",
  MIXPANEL_DEBUG: process.env.REACT_APP_MIXPANEL_DEBUG ?? "",
};

const getEnvVariable = (name: string) => {
  const value = env[name];
  if (!value) {
    throw new Error(`${name} env variable is not set.`);
  }
  return value;
};

export const MIXPANEL_TOKEN = getEnvVariable("MIXPANEL_TOKEN");
export const MIXPANEL_API_HOST = getEnvVariable("MIXPANEL_API_HOST");
export const BACKEND_URL = getEnvVariable("BACKEND_URL");
export const MIXPANEL_DEBUG = getEnvVariable("MIXPANEL_DEBUG");
